// src/components/ProductsPage/packaging/PackagingList.jsx
import React from "react";
import PackagingCard from "./PackagingCard";

export default function PackagingList({ packagings, onEdit, onDelete }) {
  if (!packagings.length) {
    return (
      <div className="p-6 border border-dashed rounded text-center text-gray-500">
        Упаковок пока нет. Добавьте первую, чтобы можно было считать packing list.
      </div>
    );
  }

  return (
    <div className="grid gap-4 md:grid-cols-2">
      {packagings.map((pkg) => (
        <PackagingCard
          key={pkg.id}
          pkg={pkg}
          onEdit={() => onEdit(pkg)}
          onDelete={() => onDelete(pkg)}
        />
      ))}
    </div>
  );
}